import { PLEDGE_PROJECT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default (payload) => {
	const { recordId } = payload
	if (recordId) {
		pushRouteClient({
			routeId: PLEDGE_PROJECT_ROUTE_ID,
			routeParams: { recordId },
		})
	}
}
